export const coverFromMediaDataSet = { cy: 'cover-from-media-update' };
export const chooseCoverDataSet = { cy: 'choose-cover-button' };
